import { useState, useEffect } from "react";
import { Card } from "../ui";
import { sigteApiFetch, sigteApiFetchChecked } from "./sigteUtils";

var SIGTE_BRAND = "#0F2C70";

var CHECKLIST_PUNTOS = ["Cabina", "Puertas", "Guías", "Motor", "Variador", "Freno", "UPS",
  "Polea", "Sensores", "Iluminación", "Comunicación", "Alarmas", "Cuarto de máquinas"];
var CALIFICACION_COLOR = {
  C: { bg: "#ecfdf5", color: "#059669" },
  OBS: { bg: "#fffbeb", color: "#b45309" },
  NC: { bg: "#fef2f2", color: "#dc2626" },
  NA: { bg: "#f1f5f9", color: "#94a3b8" },
};
var TIER_COLOR = { C: { bg: "#ecfdf5", color: "#059669" }, OBS: { bg: "#fffbeb", color: "#b45309" }, NC: { bg: "#fef2f2", color: "#dc2626" } };
var RIESGO_COLOR = { "Crítico": "#dc2626", "Alto": "#ea580c", "Medio": "#d97706", "Bajo": "#059669" };

function fmtTipo(t) { return t === "supervision" ? "Supervisión" : "Mantenimiento"; }

function escapeHtml(s) {
  return String(s == null ? "" : s)
    .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;").replace(/'/g, "&#39;");
}

function ordenarChecklist(items) {
  var porPunto = {};
  (items || []).forEach(function (it) { porPunto[it.punto] = it; });
  return CHECKLIST_PUNTOS.map(function (pt) { return porPunto[pt] || { punto: pt, calificacion: null, observacion: null }; });
}

function citaLabel(normasMap, citaId) {
  var c = normasMap[citaId];
  if (!c) return null;
  return c.documento_codigo + ", " + c.numeral + " — " + c.titulo;
}

function blobToDataUrl(blob) {
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();
    reader.onload = function () { resolve(reader.result); };
    reader.onerror = function () { reject(new Error("No se pudo leer la imagen.")); };
    reader.readAsDataURL(blob);
  });
}

// ── imagen autenticada: el token va por header Authorization, no por query
// string, asi que <img src> directo no sirve. Se descarga con fetch y se
// muestra como object URL. ──
function AuthImg(p) {
  var [url, setUrl] = useState(null);
  var [err, setErr] = useState("");

  useEffect(function () {
    var cancelado = false;
    var objectUrl = null;
    setErr(""); setUrl(null);
    sigteApiFetch("/fotos/" + p.dictamenId + "/" + encodeURIComponent(p.filename))
      .then(function (r) {
        if (!r.ok) throw new Error("No se pudo cargar la imagen.");
        return r.blob();
      })
      .then(function (blob) {
        if (cancelado) return;
        objectUrl = URL.createObjectURL(blob);
        setUrl(objectUrl);
      })
      .catch(function (e) { if (!cancelado) setErr(e.message || "No se pudo cargar la imagen."); });
    return function () {
      cancelado = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [p.dictamenId, p.filename]);

  var baseStyle = Object.assign({ borderRadius: 8, border: "1px solid #e2e8f0", background: "#f8fafc", objectFit: "cover" }, p.style || {});
  if (err) return <div style={Object.assign({}, baseStyle, { display: "flex", alignItems: "center", justifyContent: "center", fontSize: 10, color: "#dc2626", textAlign: "center", padding: 4 })}>{err}</div>;
  if (!url) return <div style={Object.assign({}, baseStyle, { display: "flex", alignItems: "center", justifyContent: "center", fontSize: 10, color: "#94a3b8" })}>Cargando...</div>;
  return <img src={url} alt={p.alt || ""} style={baseStyle} />;
}

function CalifBadge(p) {
  var c = CALIFICACION_COLOR[p.value] || CALIFICACION_COLOR.NA;
  return <span style={{ padding: "3px 9px", borderRadius: 20, fontSize: 11, fontWeight: 700, background: c.bg, color: c.color }}>{p.value || "—"}</span>;
}

function ListaDictamenes(p) {
  if (p.loading) return <p style={{ color: "#64748b", fontSize: 14 }}>Cargando...</p>;
  if (p.error) return <div style={{ background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 10, padding: "10px 16px", fontSize: 13, color: "#dc2626" }}>{p.error}</div>;
  if (p.dictamenes.length === 0) return <p style={{ color: "#94a3b8", fontSize: 13 }}>No hay dictámenes registrados.</p>;

  return (
    <div style={{ overflowX: "auto" }}>
      <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
        <thead>
          <tr style={{ textAlign: "left", borderBottom: "2px solid #e2e8f0" }}>
            {["Código", "Equipo", "Cliente", "Tipo", "Fecha", "Calificación"].map(function (h) {
              return <th key={h} style={{ padding: "8px 10px", fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase" }}>{h}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {p.dictamenes.map(function (d) {
            var tc = TIER_COLOR[d.calificacion_tier] || { bg: "#f1f5f9", color: "#64748b" };
            return (
              <tr key={d.id} onClick={function () { p.onOpen(d.id); }}
                style={{ cursor: "pointer", borderBottom: "1px solid #f1f5f9" }}>
                <td style={{ padding: "10px", fontWeight: 700, color: "#0f172a" }}>{d.codigo}</td>
                <td style={{ padding: "10px", color: "#374151" }}>{d.equipo_interno || "Sin interno"}</td>
                <td style={{ padding: "10px", color: "#374151" }}>{d.cliente_nombre}</td>
                <td style={{ padding: "10px", color: "#374151" }}>{fmtTipo(d.tipo_reporte)}</td>
                <td style={{ padding: "10px", color: "#374151" }}>{d.fecha}</td>
                <td style={{ padding: "10px" }}>
                  <span style={{ padding: "4px 10px", borderRadius: 20, fontSize: 12, fontWeight: 700, background: tc.bg, color: tc.color }}>
                    {d.calificacion_pct != null ? d.calificacion_pct + "%" : "—"}
                  </span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

function DetalleDictamen(p) {
  var d = p.detalle;
  var [descargando, setDescargando] = useState(false);
  var [descargaError, setDescargaError] = useState("");

  if (p.loading) return <p style={{ color: "#64748b", fontSize: 14 }}>Cargando...</p>;
  if (p.error) return (
    <div>
      <button onClick={p.onVolver} style={{ background: "none", border: "none", color: SIGTE_BRAND, fontSize: 12, fontWeight: 600, cursor: "pointer", padding: 0, marginBottom: 14 }}>&larr; Volver</button>
      <div style={{ background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 10, padding: "10px 16px", fontSize: 13, color: "#dc2626" }}>{p.error}</div>
    </div>
  );
  if (!d) return null;

  var checklist = ordenarChecklist(d.checklist);
  var tierColor = TIER_COLOR[d.calificacion_tier] || { bg: "#f1f5f9", color: "#64748b" };
  var esSupervision = d.tipo_reporte === "supervision";

  async function descargarReporte() {
    setDescargando(true); setDescargaError("");
    try {
      var filenames = [];
      if (d.firma_tecnico_archivo) filenames.push(d.firma_tecnico_archivo);
      if (d.firma_supervisor_archivo) filenames.push(d.firma_supervisor_archivo);
      if (d.firma_cliente_archivo) filenames.push(d.firma_cliente_archivo);
      (d.fotos || []).forEach(function (f) { filenames.push(f); });
      (d.hallazgos || []).forEach(function (h) { (h.fotos || []).forEach(function (f) { filenames.push(f); }); });
      filenames = filenames.filter(function (f, i) { return filenames.indexOf(f) === i; });

      var dataUrls = {};
      for (var i = 0; i < filenames.length; i++) {
        var fn = filenames[i];
        var r = await sigteApiFetch("/fotos/" + d.id + "/" + encodeURIComponent(fn));
        if (!r.ok) throw new Error('No se pudo descargar la foto "' + fn + '" para el reporte.');
        var blob = await r.blob();
        dataUrls[fn] = await blobToDataUrl(blob);
      }

      var html = buildReporteHtml(d, p.normasMap, dataUrls, checklist, esSupervision, tierColor);
      var blobHtml = new Blob([html], { type: "text/html" });
      var url = URL.createObjectURL(blobHtml);
      var a = document.createElement("a");
      a.href = url; a.download = "Dictamen_" + d.codigo + ".html";
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (e) {
      setDescargaError(e.message || "No se pudo generar el reporte.");
    } finally {
      setDescargando(false);
    }
  }

  return (
    <div style={{ maxWidth: 820, margin: "0 auto" }}>
      <button onClick={p.onVolver} style={{ background: "none", border: "none", color: SIGTE_BRAND, fontSize: 12, fontWeight: 600, cursor: "pointer", padding: 0, marginBottom: 14 }}>&larr; Volver a Dictámenes</button>

      <Card sx={{ marginBottom: 16 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: 10 }}>
          <div>
            <h1 style={{ fontSize: 20, fontWeight: 800, color: "#0f172a", margin: 0 }}>{d.codigo}</h1>
            <p style={{ margin: "4px 0 0", fontSize: 13, color: "#64748b" }}>{fmtTipo(d.tipo_reporte) + " · " + d.fecha}</p>
          </div>
          <span style={{ padding: "6px 14px", borderRadius: 20, fontSize: 13, fontWeight: 700, background: tierColor.bg, color: tierColor.color }}>
            {d.calificacion_pct != null ? d.calificacion_pct + "%" : "Sin calificar"}
          </span>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginTop: 16, fontSize: 13 }}>
          <div><span style={{ color: "#94a3b8" }}>Cliente: </span><span style={{ color: "#374151" }}>{d.cliente_nombre}</span></div>
          <div><span style={{ color: "#94a3b8" }}>Edificio: </span><span style={{ color: "#374151" }}>{d.edificio_nombre}</span></div>
          <div><span style={{ color: "#94a3b8" }}>Equipo: </span><span style={{ color: "#374151" }}>{(d.equipo_interno || "Sin interno") + (d.equipo_modelo ? " · " + d.equipo_modelo : "")}</span></div>
          <div><span style={{ color: "#94a3b8" }}>Representante del cliente: </span><span style={{ color: "#374151" }}>{d.representante_cliente}</span></div>
          {!esSupervision ? <div><span style={{ color: "#94a3b8" }}>Técnico: </span><span style={{ color: "#374151" }}>{d.tecnico_nombre || "—"}</span></div> : null}
          <div><span style={{ color: "#94a3b8" }}>Supervisor: </span><span style={{ color: "#374151" }}>{d.supervisor_nombre || "—"}</span></div>
        </div>
        {descargaError ? <div style={{ background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 10, padding: "10px 14px", fontSize: 13, color: "#dc2626", marginTop: 14 }}>{descargaError}</div> : null}
        <div className="sigte-no-print" style={{ display: "flex", gap: 10, marginTop: 16 }}>
          <button onClick={descargarReporte} disabled={descargando} style={{ padding: "9px 16px", borderRadius: 9, border: "none", background: SIGTE_BRAND, color: "#fff", fontSize: 13, fontWeight: 700, cursor: "pointer", opacity: descargando ? 0.6 : 1 }}>{descargando ? "Generando..." : "Descargar reporte"}</button>
          <button onClick={function () { window.print(); }} style={{ padding: "9px 16px", borderRadius: 9, border: "1px solid #dde3f0", background: "#fff", color: "#374151", fontSize: 13, fontWeight: 700, cursor: "pointer" }}>Imprimir / Guardar como PDF</button>
        </div>
      </Card>

      <Card sx={{ marginBottom: 16 }}>
        <p style={{ margin: "0 0 12px", fontSize: 13, fontWeight: 700, color: "#0f172a" }}>Checklist</p>
        {checklist.map(function (it) {
          return (
            <div key={it.punto} style={{ padding: "8px 0", borderBottom: "1px solid #f1f5f9" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
                <span style={{ fontSize: 13, color: "#0f172a" }}>{it.punto}</span>
                <CalifBadge value={it.calificacion} />
              </div>
              {it.observacion ? <p style={{ margin: "6px 0 0", fontSize: 12, color: "#64748b" }}>{it.observacion}</p> : null}
            </div>
          );
        })}
      </Card>

      <Card sx={{ marginBottom: 16 }}>
        <p style={{ margin: "0 0 12px", fontSize: 13, fontWeight: 700, color: "#0f172a" }}>{"Hallazgos (" + (d.hallazgos || []).length + ")"}</p>
        {(d.hallazgos || []).length === 0 ? <p style={{ color: "#94a3b8", fontSize: 13 }}>Sin hallazgos.</p> : null}
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          {(d.hallazgos || []).map(function (h, i) {
            var cita = citaLabel(p.normasMap, h.cita_id);
            return (
              <div key={h.id || i} style={{ border: "1px solid #e2e8f0", borderRadius: 12, padding: 14 }}>
                <div style={{ display: "flex", justifyContent: "space-between", gap: 10 }}>
                  <div>
                    {h.categoria ? <p style={{ margin: 0, fontSize: 10, fontWeight: 700, color: "#94a3b8", textTransform: "uppercase" }}>{h.categoria}</p> : null}
                    <p style={{ margin: "2px 0 0", fontSize: 13, color: "#374151" }}>{h.descripcion}</p>
                  </div>
                  <span style={{ fontSize: 10, fontWeight: 700, padding: "2px 8px", borderRadius: 20, height: "fit-content", color: RIESGO_COLOR[h.riesgo] || "#64748b", border: "1px solid " + (RIESGO_COLOR[h.riesgo] || "#64748b") }}>{h.riesgo}</span>
                </div>
                <div style={{ marginTop: 8, display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, fontSize: 11 }}>
                  <div><span style={{ color: "#94a3b8" }}>Recomendación: </span><span style={{ color: "#374151" }}>{h.recomendacion || "—"}</span></div>
                  <div><span style={{ color: "#94a3b8" }}>Tiempo: </span><span style={{ color: "#374151" }}>{h.tiempo || "—"}</span></div>
                </div>
                <p style={{ margin: "8px 0 0", fontSize: 11 }}><span style={{ color: "#94a3b8" }}>Normativa: </span><span style={{ color: "#374151" }}>{cita || "Sin norma vinculada"}</span></p>
                {(h.fotos || []).length > 0 ? (
                  <div style={{ marginTop: 10, display: "flex", gap: 8, flexWrap: "wrap" }}>
                    {h.fotos.map(function (f) { return <AuthImg key={f} dictamenId={d.id} filename={f} alt="" style={{ width: 64, height: 64 }} />; })}
                  </div>
                ) : null}
              </div>
            );
          })}
        </div>
      </Card>

      <Card sx={{ marginBottom: 16 }}>
        <p style={{ margin: "0 0 12px", fontSize: 13, fontWeight: 700, color: "#0f172a" }}>Evidencia general</p>
        {(d.fotos || []).length === 0 ? <p style={{ color: "#94a3b8", fontSize: 13 }}>Sin fotos.</p> : (
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            {d.fotos.map(function (f) { return <AuthImg key={f} dictamenId={d.id} filename={f} alt="" style={{ width: 84, height: 84 }} />; })}
          </div>
        )}
      </Card>

      <Card>
        <p style={{ margin: "0 0 12px", fontSize: 13, fontWeight: 700, color: "#0f172a" }}>Firmas</p>
        <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
          {!esSupervision && d.firma_tecnico_archivo ? (
            <div>
              <p style={{ margin: "0 0 6px", fontSize: 11, fontWeight: 600, color: "#64748b" }}>{"Técnico: " + (d.tecnico_nombre || "")}</p>
              <AuthImg dictamenId={d.id} filename={d.firma_tecnico_archivo} alt="Firma técnico" style={{ width: 200, height: 90 }} />
            </div>
          ) : null}
          {d.firma_supervisor_archivo ? (
            <div>
              <p style={{ margin: "0 0 6px", fontSize: 11, fontWeight: 600, color: "#64748b" }}>{"Supervisor: " + (d.supervisor_nombre || "")}</p>
              <AuthImg dictamenId={d.id} filename={d.firma_supervisor_archivo} alt="Firma supervisor" style={{ width: 200, height: 90 }} />
            </div>
          ) : null}
          {d.firma_cliente_archivo ? (
            <div>
              <p style={{ margin: "0 0 6px", fontSize: 11, fontWeight: 600, color: "#64748b" }}>{"Representante del cliente: " + (d.representante_cliente || "")}</p>
              <AuthImg dictamenId={d.id} filename={d.firma_cliente_archivo} alt="Firma cliente" style={{ width: 200, height: 90 }} />
            </div>
          ) : null}
        </div>
      </Card>
    </div>
  );
}

function buildReporteHtml(d, normasMap, dataUrls, checklist, esSupervision, tierColor) {
  var checklistRows = checklist.map(function (it) {
    var c = CALIFICACION_COLOR[it.calificacion] || CALIFICACION_COLOR.NA;
    return '<tr><td style="padding:8px;border-bottom:1px solid #f1f5f9;">' + escapeHtml(it.punto) + '</td>' +
      '<td style="padding:8px;border-bottom:1px solid #f1f5f9;"><span style="padding:3px 9px;border-radius:20px;font-size:11px;font-weight:700;background:' + c.bg + ';color:' + c.color + ';">' + escapeHtml(it.calificacion || "—") + '</span></td>' +
      '<td style="padding:8px;border-bottom:1px solid #f1f5f9;font-size:12px;color:#64748b;">' + escapeHtml(it.observacion || "") + '</td></tr>';
  }).join("");

  var hallazgosHtml = (d.hallazgos || []).map(function (h) {
    var cita = citaLabel(normasMap, h.cita_id);
    var fotos = (h.fotos || []).map(function (f) {
      return dataUrls[f] ? '<img src="' + dataUrls[f] + '" style="width:80px;height:80px;object-fit:cover;border-radius:8px;border:1px solid #e2e8f0;margin:4px;"/>' : "";
    }).join("");
    return '<div style="border:1px solid #e2e8f0;border-radius:12px;padding:14px;margin-bottom:12px;">' +
      (h.categoria ? '<p style="margin:0;font-size:10px;font-weight:700;color:#94a3b8;text-transform:uppercase;">' + escapeHtml(h.categoria) + '</p>' : "") +
      '<p style="margin:2px 0 8px;font-size:13px;color:#374151;"><b>' + escapeHtml(h.riesgo) + '</b> — ' + escapeHtml(h.descripcion) + '</p>' +
      '<p style="margin:0;font-size:12px;color:#64748b;">Recomendación: ' + escapeHtml(h.recomendacion || "—") + '</p>' +
      '<p style="margin:2px 0 0;font-size:12px;color:#64748b;">Tiempo: ' + escapeHtml(h.tiempo || "—") + '</p>' +
      '<p style="margin:6px 0 0;font-size:12px;color:#64748b;">Normativa: ' + escapeHtml(cita || "Sin norma vinculada") + '</p>' +
      (fotos ? '<div style="margin-top:8px;">' + fotos + '</div>' : "") +
      '</div>';
  }).join("");

  var fotosGeneralesHtml = (d.fotos || []).map(function (f) {
    return dataUrls[f] ? '<img src="' + dataUrls[f] + '" style="width:100px;height:100px;object-fit:cover;border-radius:8px;border:1px solid #e2e8f0;margin:4px;"/>' : "";
  }).join("");

  var firmasHtml = "";
  if (!esSupervision && d.firma_tecnico_archivo && dataUrls[d.firma_tecnico_archivo]) {
    firmasHtml += '<div style="display:inline-block;margin-right:20px;"><p style="font-size:11px;color:#64748b;">Técnico: ' + escapeHtml(d.tecnico_nombre || "") + '</p><img src="' + dataUrls[d.firma_tecnico_archivo] + '" style="width:220px;border:1px solid #e2e8f0;border-radius:8px;"/></div>';
  }
  if (d.firma_supervisor_archivo && dataUrls[d.firma_supervisor_archivo]) {
    firmasHtml += '<div style="display:inline-block;margin-right:20px;"><p style="font-size:11px;color:#64748b;">Supervisor: ' + escapeHtml(d.supervisor_nombre || "") + '</p><img src="' + dataUrls[d.firma_supervisor_archivo] + '" style="width:220px;border:1px solid #e2e8f0;border-radius:8px;"/></div>';
  }
  if (d.firma_cliente_archivo && dataUrls[d.firma_cliente_archivo]) {
    firmasHtml += '<div style="display:inline-block;"><p style="font-size:11px;color:#64748b;">Representante del cliente: ' + escapeHtml(d.representante_cliente || "") + '</p><img src="' + dataUrls[d.firma_cliente_archivo] + '" style="width:220px;border:1px solid #e2e8f0;border-radius:8px;"/></div>';
  }

  return '<!doctype html><html lang="es"><head><meta charset="utf-8"/><title>Dictamen ' + escapeHtml(d.codigo) + '</title></head>' +
    '<body style="font-family:Arial,Helvetica,sans-serif;color:#0f172a;max-width:820px;margin:0 auto;padding:24px;">' +
    '<h1 style="font-size:22px;margin:0;">' + escapeHtml(d.codigo) + '</h1>' +
    '<p style="color:#64748b;margin:4px 0 0;">' + escapeHtml(fmtTipo(d.tipo_reporte)) + ' · ' + escapeHtml(d.fecha) +
    ' · <span style="padding:4px 10px;border-radius:20px;background:' + tierColor.bg + ';color:' + tierColor.color + ';font-weight:700;">' + (d.calificacion_pct != null ? d.calificacion_pct + "%" : "Sin calificar") + '</span></p>' +
    '<div style="margin-top:16px;font-size:13px;">' +
    '<p><b>Cliente:</b> ' + escapeHtml(d.cliente_nombre) + '</p>' +
    '<p><b>Edificio:</b> ' + escapeHtml(d.edificio_nombre) + '</p>' +
    '<p><b>Equipo:</b> ' + escapeHtml((d.equipo_interno || "Sin interno") + (d.equipo_modelo ? " · " + d.equipo_modelo : "")) + '</p>' +
    '<p><b>Representante del cliente:</b> ' + escapeHtml(d.representante_cliente) + '</p>' +
    (!esSupervision ? '<p><b>Técnico:</b> ' + escapeHtml(d.tecnico_nombre || "—") + '</p>' : "") +
    '<p><b>Supervisor:</b> ' + escapeHtml(d.supervisor_nombre || "—") + '</p>' +
    '</div>' +
    '<h2 style="font-size:16px;margin-top:24px;">Checklist</h2>' +
    '<table style="width:100%;border-collapse:collapse;font-size:13px;">' + checklistRows + '</table>' +
    '<h2 style="font-size:16px;margin-top:24px;">Hallazgos</h2>' +
    (hallazgosHtml || '<p style="color:#94a3b8;">Sin hallazgos.</p>') +
    '<h2 style="font-size:16px;margin-top:24px;">Evidencia general</h2>' +
    (fotosGeneralesHtml || '<p style="color:#94a3b8;">Sin fotos.</p>') +
    '<h2 style="font-size:16px;margin-top:24px;">Firmas</h2>' +
    '<div>' + firmasHtml + '</div>' +
    '</body></html>';
}

export function SigteDictamenes() {
  var [view, setView] = useState("list");
  var [dictamenes, setDictamenes] = useState([]);
  var [loading, setLoading] = useState(true);
  var [error, setError] = useState("");
  var [normasMap, setNormasMap] = useState({});
  var [normasError, setNormasError] = useState("");

  var [detalle, setDetalle] = useState(null);
  var [detalleLoading, setDetalleLoading] = useState(false);
  var [detalleError, setDetalleError] = useState("");

  function loadLista() {
    setLoading(true); setError("");
    sigteApiFetchChecked("/dictamenes")
      .then(function (body) { setDictamenes(body.dictamenes || []); setLoading(false); })
      .catch(function (e) { setError(e.message); setLoading(false); });
  }

  function loadNormas() {
    setNormasError("");
    sigteApiFetchChecked("/normas")
      .then(function (body) {
        var map = {};
        (body.normas || []).forEach(function (doc) {
          (doc.citas || []).forEach(function (cita) {
            map[cita.id] = { documento_codigo: doc.codigo, numeral: cita.numeral, titulo: cita.titulo };
          });
        });
        setNormasMap(map);
      })
      .catch(function (e) { setNormasError(e.message || "No se pudieron cargar las normas citadas."); });
  }

  useEffect(function () { loadLista(); loadNormas(); }, []);

  function abrirDetalle(id) {
    setDetalle(null); setDetalleError(""); setDetalleLoading(true); setView("detail");
    sigteApiFetchChecked("/dictamenes/" + id)
      .then(function (body) { setDetalle(body.dictamen); setDetalleLoading(false); })
      .catch(function (e) { setDetalleError(e.message); setDetalleLoading(false); });
  }

  function volver() { setView("list"); setDetalle(null); setDetalleError(""); }

  return (
    <div>
      <style>{"@media print { .sigte-no-print { display: none !important; } }"}</style>
      {view === "list" ? (
        <div>
          <div style={{ marginBottom: 20 }}>
            <h1 style={{ fontSize: 20, fontWeight: 800, color: "#0f172a", margin: 0 }}>Dictámenes</h1>
            <p style={{ color: "#64748b", fontSize: 13, marginTop: 3 }}>{dictamenes.length + " dictámenes"}</p>
          </div>
          {normasError ? <div style={{ background: "#fffbeb", border: "1px solid #fde68a", borderRadius: 10, padding: "8px 14px", fontSize: 12, color: "#b45309", marginBottom: 14 }}>{normasError}</div> : null}
          <Card>
            <ListaDictamenes dictamenes={dictamenes} loading={loading} error={error} onOpen={abrirDetalle} />
          </Card>
        </div>
      ) : (
        <DetalleDictamen detalle={detalle} loading={detalleLoading} error={detalleError} normasMap={normasMap} onVolver={volver} />
      )}
    </div>
  );
}
